import React, { useEffect } from "react";
import ContainerPop from "../../../Pops/ContainerPop";
import ButtonClose from "../../../Pops/ButtonClose";
import { CircularProgress, Input } from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

const StatusChangeModal = ({
  show,
  handleClose,
  handleSubmit,
  isLoading,
  data,
  newStatus,
}) => {
  return (
    <div
      className={`fixed inset-0 !z-50 ${
        show ? "visible" : "hidden"
      } bg-black bg-opacity-50 flex justify-center items-center`}
      onClick={handleClose}
    >
      <ContainerPop>
        <div
          aria-label="status-change-modal"
          className="swals-show flex flex-col justify-center relative box-border z-50 w-[32em] max-w-full p-4 border-0 rounded-sm bg-secondary dark:bg-darkPrimary text-darkTextColor dark:text-darkTextColor m-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold">Change Status</h2>
            <div
              className="close absolute top-6 right-4 z-50 !cursor-pointer text-textColor dark:text-darkTextColor"
              onClick={handleClose}
            >
              <IoMdCloseCircleOutline size={"1.3rem"} />{" "}
            </div>
          </div>
          <div className="flex flex-col w-full items-center justify-center">
            <div className="flex items-center justify-center w-[5em] h-[5em] mt-[1.25em] mx-auto mb-[1.875em] border-[.25em] border-[#facea8] text-[#facea8] rounded-full cursor-default">
              <div className="text-[3.75rem] leading-[5rem]">!</div>
            </div>
            <div className="relative flex justify-center items-center font-bold text-[#6c757d] text-3xl text-center mb-3">
              Are you sure?
            </div>
            <div className="w-full flex items-center justify-center flex-wrap">
              <button
                type="button"
                onClick={() => {
                  handleSubmit(data?.id, newStatus);
                }}
                disabled={isLoading}
                className={`m-1 py-2 px-8 font-medium text-[1.0625em] rounded-[0.25em] text-darkTextColor flex justify-center w-44 bg-primary`}
              >
                {isLoading ? (
                  <CircularProgress size={24} sx={{ color: "white" }} />
                ) : (
                  "Submit"
                )}
              </button>
              <ButtonClose onClick={() => handleClose()} />
            </div>
          </div>
        </div>
      </ContainerPop>
    </div>
  );
};

export default StatusChangeModal;
